import { render } from "./UiLoadingDialog.vue?vue&type=template&id=69851d20&ts=true"
import script from "./UiLoadingDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./UiLoadingDialog.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/UiLoadingDialog.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "69851d20"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('69851d20', __exports__)) {
    api.reload('69851d20', __exports__)
  }
  
  module.hot.accept("./UiLoadingDialog.vue?vue&type=template&id=69851d20&ts=true", () => {
    api.rerender('69851d20', render)
  })

}


export default __exports__